import React from "react"

// Boîte auteur E-E-A-T des pages Hôtels & Palaces (Toscane, Paris).
// Photo auto-hébergée (static/hotels/team/), texte FR/EN.
const CONTENT = {
  fr: {
    label: "L'auteur",
    name: "Pierre-Axel Gadait",
    role: "Fondateur & CEO, GADAIT International",
    bio: "Conseil en immobilier et séjours de luxe — partenaire hôtelier officiel du Monteverdi Tuscany et de Maison Bauchart à Paris, sélection éditoriale indépendante pour les autres maisons. Chaque fait de cette page est sourcé (Guide Michelin, supports publics des maisons) et daté ; les pages sont re-vérifiées chaque trimestre.",
    methodHref: "/fr/notre-methode-editoriale/",
    methodLabel: "Notre méthode éditoriale →",
    cta: "Écrire à l'équipe",
    ctaHref: "/fr/hotels-et-palaces/",
    ctaLabel: "La collection Hôtels & Palaces",
  },
  en: {
    label: "The author",
    name: "Pierre-Axel Gadait",
    role: "Founder & CEO, GADAIT International",
    bio: "Luxury real-estate and stay advisory — official hotel partner of Monteverdi Tuscany and Maison Bauchart in Paris, independent editorial selection for the other houses. Every fact on this page is sourced (Michelin Guide, the houses' public materials) and dated; pages are re-verified quarterly.",
    methodHref: "/en/our-editorial-method/",
    methodLabel: "Our editorial method →",
    cta: "Write to the team",
    ctaHref: "/en/hotels-and-palaces/",
    ctaLabel: "The Hotels & Palaces collection",
  },
}

// Variante « immobilier » : mêmes composants, mais des preuves d'expertise
// adaptées aux pages propriété (Maurice, Marbella, hubs destination) — la
// biographie Hôtels & Palaces ci-dessus n'y a pas sa place (Monteverdi, Michelin).
const CONTENT_REALESTATE = {
  fr: {
    label: "L'auteur",
    name: "Pierre-Axel Gadait",
    role: "Fondateur & CEO, GADAIT International",
    bio: "Chasseur immobilier de luxe, du côté de l'acquéreur uniquement — Maurice, Dubaï, Marbella, Grèce, Maldives et Alpes. Chaque prix et chaque règle de cette page sont sourcés (%s) et datés ; les pages sont re-vérifiées chaque trimestre.",
    sources: "promoteurs, bureaux de vente, textes officiels",
    methodHref: "/fr/notre-methode-editoriale/",
    methodLabel: "Notre méthode éditoriale →",
  },
  en: {
    label: "The author",
    name: "Pierre-Axel Gadait",
    role: "Founder & CEO, GADAIT International",
    bio: "Luxury buyer's agent, on the buyer's side only — Mauritius, Dubai, Marbella, Greece, the Maldives and the French Alps. Every price and every rule on this page is sourced (%s) and dated; pages are re-verified quarterly.",
    sources: "developers, sales offices, official texts",
    methodHref: "/en/our-editorial-method/",
    methodLabel: "Our editorial method →",
  },
}

// Variante « vendeur » : sur les pages de mandat de vente, la biographie
// immobilier ci-dessus est à proscrire — elle affirme « du côté de
// l'acquéreur uniquement », ce qui contredirait frontalement la page.
const CONTENT_SELLER = {
  fr: {
    label: "L'auteur",
    name: "Pierre-Axel Gadait",
    role: "Fondateur & CEO, GADAIT International",
    bio: "Mandats de vente pour propriétaires privés et promoteurs — Marbella, Grèce, Dubaï, Maurice, Maldives et Alpes. Sur une transaction donnée nous agissons pour un seul côté, et nous disons lequel. Chaque taux et chaque frais de cette page sont sourcés (textes officiels, cadastres, autorités fiscales) et datés ; les pages sont re-vérifiées chaque trimestre.",
    methodHref: "/fr/notre-methode-editoriale/",
    methodLabel: "Notre méthode éditoriale →",
  },
  en: {
    label: "The author",
    name: "Pierre-Axel Gadait",
    role: "Founder & CEO, GADAIT International",
    bio: "Sale mandates for private owners and developers — Marbella, Greece, Dubai, Mauritius, the Maldives and the French Alps. On any given transaction we act for one side, and we say which. Every rate and every fee on this page is sourced (official texts, land registries, tax authorities) and dated; pages are re-verified quarterly.",
    methodHref: "/en/our-editorial-method/",
    methodLabel: "Our editorial method →",
  },
}

const VARIANTS = { hotels: CONTENT, realestate: CONTENT_REALESTATE, seller: CONTENT_SELLER }

// Sources officielles citées dans la biographie « immobilier », par marché :
// les textes EDB/MRA ne valent que pour Maurice.
const MARKET_SOURCES = {
  mauritius: {
    fr: "promoteurs, bureaux de vente, textes officiels EDB/MRA",
    en: "developers, sales offices, official EDB/MRA texts",
  },
  france: {
    fr: "notaires, Légifrance, impots.gouv.fr, Notaires de France",
    en: "notaries, Légifrance, impots.gouv.fr, Notaires de France",
  },
  marbella: {
    fr: "promoteurs, Notariado, Registro de la Propiedad, Agencia Tributaria",
    en: "developers, Notariado, Registro de la Propiedad, Agencia Tributaria",
  },
  dubai: {
    fr: "promoteurs, Dubai Land Department, RERA",
    en: "developers, Dubai Land Department, RERA",
  },
  greece: {
    fr: "promoteurs, notaires, Enterprise Greece, AADE",
    en: "developers, notaries, Enterprise Greece, AADE",
  },
  maldives: {
    fr: "promoteurs, opérateurs hôteliers, MIRA, Invest Maldives",
    en: "developers, hotel operators, MIRA, Invest Maldives",
  },
  unitedStates: {
    fr: "promoteurs, IRS, registres des comtés",
    en: "developers, IRS, county records",
  },
}

const AuthorBox = ({ locale = "fr", variant = "hotels", market }) => {
  const c = (VARIANTS[variant] || CONTENT)[locale]
  const bio = c.sources
    ? c.bio.replace("%s", MARKET_SOURCES[market]?.[locale] || c.sources)
    : c.bio
  return (
    <div style={{ display:"flex", gap:20, alignItems:"flex-start", background:"#f5f5f7", border:"1px solid rgba(0,0,0,0.06)", borderRadius:20, padding:"24px 28px", margin:"8px 0" }}>
      <img
        src="/hotels/team/pierre-axel.webp"
        alt={c.name}
        width="72"
        height="72"
        loading="lazy"
        style={{ width:72, height:72, borderRadius:"50%", objectFit:"cover", flexShrink:0, border:"2px solid #fff", boxShadow:"0 2px 12px rgba(0,0,0,0.12)" }}
      />
      <div>
        <div style={{ fontSize:11, letterSpacing:"0.16em", textTransform:"uppercase", color:"#6e6e73", marginBottom:6 }}>{c.label}</div>
        <div style={{ fontWeight:700, fontSize:17, color:"#1d1d1f", letterSpacing:"-0.02em" }}>{c.name}</div>
        <div style={{ fontSize:13, color:"#6e6e73", marginBottom:8 }}>{c.role}</div>
        <p style={{ fontSize:14, lineHeight:1.6, color:"#3d3d3f", margin:0 }}>{bio}</p>
        <a href={c.methodHref} style={{ display:"inline-flex", alignItems:"center", minHeight:40, marginTop:0, fontSize:13, color:"#0071e3", fontWeight:600, textDecoration:"none" }}>{c.methodLabel}</a>
      </div>
    </div>
  )
}

export default AuthorBox
